module.exports = __webpack_public_path__ + "static/media/minibg.c95cad07.jpg";